import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { IconProps } from "./types";

export function ArrowLeftIcon({ size, ...props }: IconProps) {
    return <ArrowBackRoundedIcon fontSize={size} {...props} />;
}
